/*
 * @Author: maqian
 * @Date: 2023-12-25 16:39:26
 * @LastEditors: maqian maqian@aeonmed.com
 * @LastEditTime: 2025-03-14 14:14:17
 * @Description:
 */
import Vue from 'vue'
import Router from 'vue-router'
import Index from '@/components/Index'
import LuvMe from '@/components/luvme'
import LuvLink from '@/components/luvlink'
Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'Index',
      component: Index
    },
    {
      path: '/luvme',
      name: 'LuvMe',
      component: LuvMe
    },
    {
      path: '/luvlink',
      name: 'LuvLink',
      component: LuvLink
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js